import toastMessage from './toasts'

export default toastMessage
